var _path, _path2, _path3, _path4, _path5, _linearGradient, _path6, _path7, _path8, _linearGradient2, _path9, _linearGradient3, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaRapido2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 5.08c22.33 0 36.78 18.49 32.27 41.28-4.5 22.8-26.25 41.28-48.58 41.28S1.66 69.15 6.17 46.36 32.42 5.08 54.75 5.08z",
    fill: "#d3d6d8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.84 2.25c22.33 0 36.79 18.48 32.28 41.28S58.86 84.81 36.53 84.81-.25 66.32 4.26 43.53C8.76 20.72 30.52 2.25 52.84 2.25z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.88 2C74.3 2 88.8 20.55 84.28 43.44S57.92 84.88 35.51 84.88-1.41 66.32 3.11 43.44C7.64 20.55 29.47 2 51.88 2z",
    fill: "#f4fafc"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2b8159"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.83 45.63c.04.21.2 2.42.2 2.42s-.13.21-.32.37c-.18.15-.38-.01-.43-.12-.05-.12-1.77-3.4-1.93-3.45-.14-.06-5.61.42-8.6 2.13-2.99 1.72-5 4.66-6.01 7.49s-.4 5.41.14 6.44c.53 1.05 2.73 3.95 3.14 4.68.41.74.29 1.28.29 1.28s.46-.08.59.04-2.16 5.02-8.38 9.17c-6.22 4.17-6.99 3.54-6.99 3.54s-.6.33-2.84-2.45c-2.25-2.78-4.61-4.43-7.85-3.94-3.23.5-6.12 1.82-8.12 4.22-2 2.39-3.22 6.28-3.52 6.99-.3.7-.32.91-.32.91l3.94 1.86c.5.21.5.26.35.48-.13.23-.3.31-.3.31s-1.24-.15-1.6-.26c-.37-.11-6.91-1.75-7.34-4.33-.43-2.59 4.99-21.78 16.78-31.83 11.78-10.04 34.08-13.93 39.12-5.95z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.87 88s-8.18-.18-14.13-2.6c-5.94-2.41-6.33-3.23-6.33-3.23s-.17-.48-.02-1.04c.15-.55 15.24 4.01 15.24 4.01s2.57 1.68 3.73 2.26c1.17.58 1.51.6 1.51.6z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.92 66.92s2.41 2.22 2.57 2.69c.15.47.38.3-1.06 1.99s-5.47 5.56-8.21 7.53-4.43 2.89-4.97 3.08c-.54.18-1.49-.83-2.05-1.31-.56-.47-1.91-1.24-1.64-1.33.28-.09 4.79-2.67 8.57-5.95 3.78-3.27 6.14-6.08 6.32-6.33.18-.26.47-.37.47-.37zm13.12-18.87s-.03-.43-.84-1.86-1.24-1.86-1.24-1.86-.29-.79-.08-2.03c.2-1.25.76-7.3.61-10.18-.16-2.87-.58-4.88-.47-4.62.11.28 1.83 2.66 2.4 4.83.56 2.17.67 8.08.45 11.02-.23 2.96-.5 4.68-.83 4.7z",
    fill: "#329f79"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 71.597,
    y1: 68.641,
    x2: 18.974,
    y2: 19.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#6eedd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#6bebd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#46c7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#38baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#38baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#34b7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2aaf9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19a38f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16 68.78s-1.8-3.44-2.93-6.83-1.35-8.31-1.12-8.32c.22-.02 6.42-2.53 8.14-8.82 1.71-6.29-2.83-8.34-3.78-8.94s-1.66-.75-1.18-1.88c.47-1.13 1.27-3.15 2.9-6.13 1.62-2.99 4.33-6.82 5.13-6.89s5.13 3.21 10.3-1.18 4.42-7.65 4.42-8.65-.23-3 .36-3.47c.6-.46 2.72-1.56 6.14-2.93 3.42-1.38 6.61-2.47 7.63-2.31 1.01.15.73.77 1.42 3.01.67 2.24 2.82 4.54 6.27 4.64 3.44.09 5.76-1.52 7.41-3.14 1.65-1.63 3.65-3.79 4.12-4.01.47-.23 3.17.43 6.54 2.13 3.38 1.69 6.45 3.95 6.68 4.41.22.45.22.68-.6 1.76-.84 1.08-4.48 6.26-3.58 9.99s4.07 5.22 5.62 5.5c1.56.27 7.72.01 8.19.24.46.23.79-.03 1.13 1.56.35 1.6.54 3.3.6 6.32a39.59 39.59 0 0 1-.47 6.7c-.14.88-.51 2.81-.51 2.81s-.17-.14-.83-.18c-.64-.03-6.56.26-10.06 2.7-3.51 2.45-4.77 5.48-5.17 8.97-.41 3.48 0 4.3.85 5.75.86 1.45 2.72 3.75 3.04 4.43s.13.86-.13 1.24c-.28.39-4.97 5.48-8.25 7.71-3.28 2.24-5.89 4.07-6.36 3.96-.48-.11-4.14-5.2-7.63-6.27s-8.79.88-10.9 3.68c-2.11 2.81-3.87 7.52-3.94 8.03-.06.51.11 1.7-3.35 1.24-3.46-.45-8.29-1.58-9.55-2.05-1.25-.48-3.36-1.5-3.32-2.2.05-.7 2.72-7.49.63-11.06-2.09-3.58-4.61-4.66-7.78-3.75s-4.9 1.51-5.15 1.73c-.29.23-.39.7-.93.5z",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.21 9.06c-.19.62-.6 1.51-1.43 2.81-2.16 3.39-3.51 5.6-2.93 9.54.42 2.79 3.2 4.74 5.3 5.07-1.65-.57-4.01-2.13-4.76-5.26-.9-3.73 2.74-8.92 3.58-9.99.83-1.09.83-1.31.6-1.76-.04-.09-.16-.23-.36-.41zM42.17 2.42c.3.49.58 1.12.8 1.94.76 2.79 1.85 4.78 4.4 5.21a6.527 6.527 0 0 1-3.81-4.14c-.68-2.22-.42-2.84-1.39-3.01z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.84 34.15 84.48 41c-.2 2.43-.65 2.99.11 2.85.76-.13.88-3.46.94-5.86.08-2.39-.02-4.33-.69-3.84zm-13.06 30.9s1.04 1.02.85 1.73c-.2.72-6.01 6.19-8.62 8.03s-6 3.9-6 3.9.27.42 3.62-1.89c3.35-2.3 5.76-4.23 7.08-5.52 1.33-1.29 3.96-3.94 4.1-4.31.13-.36.34-.56-.32-1.48-.64-.91-.98-.98-.71-.46zm-.25-15.19s-1.76 2.63-2.2 4.29c-.43 1.67-.45 3.07-.38 4.5.07 1.45-.86-1.02-.39-3.96.48-2.93 2.74-5.26 2.97-4.83zm-32.9 28.4s-1.49 2.44-2.08 4.32c-.6 1.88-.79 2.47-1.1 2.68-.32.22-.38-.57-.18-.77.19-.18.4-.89 1.08-2.64.68-1.73 2.2-4.7 2.28-3.59zm35-68.2s-2.08 2.64-3.18 4.92c-1.11 2.28-.87 3.47-.6 3.11.28-.35.5-1.9 1.59-3.63l2.55-4.07c.17-.42-.23-.43-.36-.33z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 7.21c1.52-.26 2.83.63 2.95 1.97.1 1.33-1.04 2.64-2.56 2.89-1.52.26-2.83-.63-2.94-1.97-.11-1.33 1.03-2.63 2.55-2.89z",
    style: {
      fill: "#2b8159"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.12 8.22c1.17-.19 2.14.48 2.14 1.52.01 1.03-.95 2.02-2.12 2.22-1.18.19-2.15-.47-2.15-1.51-.01-1.03.95-2.03 2.13-2.23z",
    fill: "#f4fafc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.86 8.71c.3.12.43.5.29.86-.13.35-.49.54-.8.42-.3-.12-.43-.5-.29-.86.15-.35.5-.53.8-.42z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3 12.6c.75-.18 1.4.26 1.43.96.04.72-.55 1.46-1.31 1.63-.76.18-1.4-.25-1.44-.96-.03-.72.56-1.45 1.32-1.63z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.67 13.34c.17.16.15.45-.04.65-.19.19-.48.23-.64.06-.16-.16-.15-.46.04-.66s.47-.22.64-.05z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86 13.68c.35-.08.65.02.84.24-.13.6-.64 1.13-1.27 1.27-.11.03-.22.04-.33.04a.736.736 0 0 1-.15-.42c-.03-.49.38-1 .91-1.13z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09 33.03c1.71-.31 3.12.72 3.16 2.29s-1.32 3.08-3.03 3.38c-1.71.31-3.13-.72-3.17-2.29-.03-1.57 1.33-3.08 3.04-3.38z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.44 34.2c1.24-.23 2.26.52 2.26 1.66.01 1.13-1 2.23-2.24 2.44-1.25.22-2.26-.52-2.27-1.66-.01-1.12.99-2.22 2.25-2.44z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9 34.64c.3.14.39.58.22.98s-.54.62-.84.46c-.29-.14-.39-.58-.21-.98.17-.39.54-.6.83-.46z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.22 35.02c.95-.15 1.76.39 1.84 1.22.06.84-.65 1.64-1.59 1.81-.94.15-1.76-.39-1.83-1.22-.07-.84.64-1.64 1.58-1.81z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81 36.02c.57-.08.96.21.87.65-.09.45-.63.88-1.2.96s-.96-.21-.87-.65c.1-.45.63-.88 1.2-.96z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 35.73c.22.09.31.39.17.67-.12.28-.41.42-.64.33-.22-.09-.31-.39-.17-.67.12-.28.42-.42.64-.33z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24 63.04c.97-.17 1.8.44 1.87 1.38s-.65 1.86-1.62 2.03c-.96.18-1.79-.43-1.87-1.37-.06-.94.66-1.85 1.62-2.04z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.31 64.34c.56-.34 1.15-.28 1.32.12.17.41-.14 1.02-.7 1.35-.56.35-1.15.29-1.32-.11-.18-.4.14-1.01.7-1.36z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.42 63.94c.2.15.21.54.03.87s-.51.48-.71.33-.21-.54-.03-.87c.19-.33.51-.48.71-.33z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.52 65.98c1.7-.35 3.17.84 3.29 2.67.12 1.82-1.16 3.57-2.86 3.92s-3.17-.84-3.29-2.67c-.1-1.81 1.17-3.57 2.86-3.92z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1 67.15c1.21-.26 2.2.63 2.2 1.95.01 1.33-.97 2.62-2.18 2.87s-2.19-.62-2.2-1.95c0-1.33.97-2.61 2.18-2.87z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 68.01c.28.25.29.81.02 1.28-.25.46-.68.65-.96.4-.27-.24-.28-.81-.02-1.27.26-.47.69-.65.96-.41z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.18 76.1c1.52-.4 2.83.54 2.95 2.1.1 1.57-1.04 3.16-2.56 3.57-1.52.4-2.83-.54-2.94-2.1-.11-1.57 1.03-3.17 2.55-3.57z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8 77.43c.98-.85 2.24-.77 2.82.17.58.95.25 2.41-.72 3.25-.98.85-2.24.77-2.82-.18-.58-.94-.26-2.4.72-3.24z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.52 77.8c.29.12.39.53.22.91s-.54.57-.84.45c-.29-.13-.39-.54-.21-.91.17-.38.54-.58.83-.45z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.17 71.57c.84-.17 1.56.42 1.62 1.32.06.91-.57 1.79-1.41 1.96s-1.56-.42-1.62-1.32c-.06-.92.57-1.79 1.41-1.96z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.74 72.41c.51-.12.89.27.83.86-.05.6-.51 1.17-1.02 1.28-.52.12-.89-.27-.84-.86.05-.6.52-1.17 1.03-1.28z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29 72.47c.23.1.35.41.22.7-.11.29-.4.43-.64.34-.24-.1-.35-.41-.23-.7s.41-.43.65-.34z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24 56.85c1.25-.3 2.36.5 2.44 1.8.09 1.29-.86 2.59-2.12 2.88-1.25.31-2.36-.5-2.44-1.8-.1-1.29.85-2.57 2.12-2.88z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85 57.17c.52-.1.99 0 1.35.26a2.02 2.02 0 0 1 .48 1.22c.05.66-.17 1.31-.57 1.85-.34.33-.76.57-1.23.67-1.1.21-2-.51-2.01-1.62s.88-2.17 1.98-2.38z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67 58.12c.31.11.43.46.29.78-.13.32-.49.49-.8.38-.3-.1-.43-.45-.29-.78.14-.32.5-.5.8-.38z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.51 55.79c.56-.33 1.16-.21 1.35.27.18.47-.12 1.12-.68 1.45s-1.16.21-1.35-.27.12-1.12.68-1.45z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.34 56.05a1.15 1.15 0 0 1 .53.04c.15.47-.15 1.09-.69 1.41-.2.11-.42.17-.61.18a.73.73 0 0 1-.25-.55c-.01-.5.44-.98 1.02-1.08z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.04 56.23c.05.18-.09.38-.31.44-.22.05-.44-.05-.49-.24s.09-.39.32-.44c.22-.05.44.05.48.24z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68 27.33c1.2-.39 2.25.14 2.33 1.19.08 1.06-.83 2.23-2.03 2.62-1.2.4-2.25-.13-2.34-1.19-.07-1.05.84-2.22 2.04-2.62z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.18 27.59c.98-.27 1.78.28 1.78 1.21.01.94-.79 1.92-1.77 2.19-.99.27-1.78-.29-1.79-1.22 0-.94.79-1.92 1.78-2.18z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.31 28.24c.22.09.33.38.21.65-.1.26-.37.4-.59.31-.22-.08-.32-.37-.21-.64s.36-.4.59-.32z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.43 29.77c.57-.24 1.08-.05 1.13.42s-.37 1.06-.94 1.29c-.58.25-1.08.05-1.13-.42s.36-1.04.94-1.29z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.95 30.06c.21-.07.42-.08.57-.03a.75.75 0 0 1 .04.16c.05.47-.37 1.06-.94 1.29-.18.07-.36.11-.51.1a.533.533 0 0 1-.11-.34c-.01-.46.42-.99.95-1.18z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03 30.14c.03.14-.1.29-.31.32-.2.03-.4-.06-.43-.21-.03-.14.11-.28.31-.31s.4.06.43.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.48 6.05c1.33-.18 2.43.71 2.47 1.97.04 1.27-.99 2.45-2.31 2.63s-2.42-.7-2.46-1.97.99-2.45 2.3-2.63z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.89 7.03c1.03-.14 1.84.53 1.79 1.51-.03.97-.89 1.88-1.92 2.01-1.02.13-1.83-.54-1.79-1.51.04-.98.9-1.88 1.92-2.01z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.93 7.4c.24.12.35.49.21.82-.13.33-.45.49-.7.37-.25-.13-.35-.5-.21-.83.13-.33.45-.5.7-.36z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.23 11.54c.67-.26 1.25 0 1.31.58.04.58-.46 1.26-1.13 1.52-.67.27-1.25 0-1.31-.58-.05-.59.45-1.26 1.13-1.52z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.56 12.3c.45-.14.82.05.82.45v.02a1.87 1.87 0 0 1-.98.87c-.11.05-.23.08-.34.09a.479.479 0 0 1-.32-.45c.01-.4.37-.83.82-.98z",
    style: {
      fill: "#fff3fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.42 11.92c.12.06.19.28.13.47-.05.19-.2.31-.34.24-.13-.06-.19-.28-.14-.47.07-.2.22-.31.35-.24z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.17 15.03c14.23 0 23.7 11.84 21.15 26.43-2.56 14.59-16.16 26.42-30.4 26.42S13.21 56.04 15.77 41.46c2.55-14.59 16.16-26.43 30.4-26.43z",
    style: {
      fill: "#19a38f"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.23 15.87c13.83 0 22.97 11.52 20.43 25.74s-15.8 25.74-29.62 25.74-22.96-11.52-20.42-25.74 15.79-25.74 29.61-25.74z",
    fill: "#fef0fd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 56.917,
    y1: 56.836,
    x2: 26.131,
    y2: 26.049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#6eedd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#6bebd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#46c7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#38baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#38baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#34b7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2aaf9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19a38f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.89 17.72c12.81 0 21.23 10.63 18.81 23.72-2.42 13.1-14.75 23.72-27.56 23.72S15.91 54.54 18.33 41.44s14.76-23.72 27.56-23.72zm-.54 2.47c11.18 0 18.4 9.36 16.15 20.9-2.25 11.53-13.13 20.89-24.31 20.89s-18.4-9.36-16.15-20.89c2.26-11.55 13.14-20.9 24.31-20.9z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.35 20.19c4.97 0 9.16 1.85 12.07 4.91-2.93-3.39-7.31-5.46-12.56-5.46-11.18 0-22.07 9.36-24.32 20.9-1.25 6.41.43 12.15 4.08 15.97-3.3-3.82-4.77-9.32-3.58-15.43 2.26-11.54 13.14-20.89 24.31-20.89z",
    style: {
      fill: "#2b8159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.95 23.46c4.14 4.35 6.08 10.79 4.75 17.97-2.42 13.1-14.75 23.72-27.56 23.72-6.07 0-11.14-2.38-14.56-6.28 3.41 3.57 8.29 5.73 14.07 5.73 12.8 0 25.14-10.62 27.55-23.72 1.28-6.88-.45-13.09-4.25-17.42z",
    style: {
      fill: "#19a38f"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.499,
    y1: 54.653,
    x2: 33.063,
    y2: 33.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#6eedd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#6bebd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#46c7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#38baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#38baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#34b7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2aaf9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19a38f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m27 50.68 7.51-23.21s.41-1.22 2.02-1.13c1.62.09 10.84.68 12.55 1.26 1.7.6 5.26 2.81 5.12 7.79-.13 4.98-3.06 7.01-4 7.74-.95.72-2.56 1.31-2.56 1.58 0 .28 1.39 8.86 1.44 9.78.04.9-.28 1.76-1.67 1.58s-5.03-.86-5.49-1.22c-.45-.36-.4-1.13-.9-3.94-.49-2.8-.76-4.92-1.03-5.24-.28-.32-3.15-.6-3.64-.41-.5.18-2.29 6.65-2.48 7.15-.17.49-.81 1.45-2.29 1.09-1.47-.38-5.61-.15-4.58-2.82zm13.08-17.72s7.32-.47 6.7 3.38c-.63 3.85-3.18 3.62-5.79 3.44-2.61-.17-2.65-.27-2.65-.27-.88-.36 1.44-5.75 1.74-6.55z",
    fill: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.35 27.71c1.43.95 3.02 2.29 3.47 3.7.85 2.71.71 5.43-.63 8.09a9.32 9.32 0 0 1-4.5 4.3c-.95.41-1.12.68-.95 1.67l1.4 9.5c-.04.58-1.08.45-2.97.09s-2.92-.35-3.17-1.02-1.36-8.38-1.84-8.86c-.47-.47-3.73-.51-4.11-.29-.39.23-2.25 7.01-2.59 7.51-.34.49-1.42.54-2.29.43-.88-.11-3.05-.02-3.77-.75-.19-.19-.38-.52-.53-.9-.35 2.13 3.34 1.96 4.72 2.3 1.49.36 2.12-.6 2.29-1.09.18-.5 1.98-6.97 2.48-7.15.49-.18 3.36.09 3.64.41.27.32.54 2.44 1.03 5.24.5 2.81.45 3.58.9 3.94.46.36 4.1 1.04 5.49 1.22 1.4.18 1.71-.68 1.67-1.58-.05-.91-1.44-9.5-1.44-9.78 0-.27 1.61-.86 2.56-1.58.94-.73 3.86-2.76 4-7.74.13-4.71-3.08-6.94-4.86-7.66zm-2.55 7.97c.42-3.54-6.3-3.79-7.14-3.18-.3.21-1.04 2.34-1.55 3.88-.63 1.9-.95 3.24.19 3.11-.79-.48 1.44-5.6 1.77-6.52.01-.01 6.45-.42 6.73 2.71z",
    style: {
      fill: "#19a38f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.71 40.82c1.31-1.72 1.64-3.26 1.94-5.36.36.87.11 4.61-1.94 5.36zm-12.64-7.79-1.5 4.77c-.25 1.07-.01.98.15.84.15-.13.35-1.03.74-2.39l.99-3.09c.04-.45-.32-.27-.38-.13zm7.77 11.63c.04.25.88.61.86.48l-.05-.43c-.13-.06-.85-.3-.81-.05zm2.12 10.01s-.85-.17-.84.07.03.3.39.31c.37.01.55-.04.45-.38zm-13.82-9.3-1.93 6.68c0 .41.32.39.5-.02.19-.42 1.63-5.24 1.87-5.84s.06-1.38-.44-.82zm25.15 4.97s1.39-2.28 2.61-5.63 1.66-6.58 1.66-6.58.08 2.68-1.08 6.56c-1.15 3.86-2.71 5.65-3.19 5.65zM20.7 41.18s.91-4 1.73-5.84c.84-1.83 1.79-3.07 1.64-3.17-.15-.09-3.12 2.87-3.37 9.01z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaRapido2);
export default __webpack_public_path__ + "static/media/russia_rapido_2.2744cce6337f146c861cce4365da8b9f.svg";
export { ForwardRef as ReactComponent };